module.exports = __webpack_public_path__ + "media/images/features/4/feature-4-item-option-ce1c358b9926bfa5a6944e2eb2cb7df4.png";